/**
 * Truncates a string to the given length, appending '...' if truncated.
 * The length includes the ellipsis characters.
 */
export function truncate(str: string, length: number) {
  const clampedLength = Math.max(3, length);
  if (str.length <= clampedLength) {
    return str;
  }
  return `${str.slice(0, clampedLength - 3)}...`;
}
